// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.historyPageBody__h5YTI {
  padding: 25px;
}

.historyPageBodyContainer__yACtq {
  position: relative;
  box-shadow: var(--select-dropdown-box-shadow);
}

.historyPageInfoPanel__RXAdF {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 15px 25px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
  box-shadow: var(--table-box-shadow);
}

.leftPart__i_gH4 {
  display: flex;
  align-items: center;
  gap: 15px;
}

.equipmentNameLabel__yqNeg {
  font-size: 11px;
  line-height: 14px;
  font-weight: 400;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  font-style: normal;
}

.equipmentName__uZ2a5 {
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
  color: var(--tables-primary-row-text-main);
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
  margin-top: 5px;
  padding: 7px 0 8px;
}

.serialNumberLabel__vavqc {
  color: var(--title-inputs-sections-title);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
}

.serialNumberField__B57VH {
  display: flex;
  align-items: center;
  column-gap: 5px;
  margin-top: 5px;
}

.serialNumber__Isott {
  font-size: 11px;
  font-weight: 500;
  line-height: 12px;
  color: var(--inputs-disable-text);
  min-width: 195px;
  padding: 11px 15px 12px;
  border-radius: 2px;
  background: var(--inputs-disable-disable-surface);
  text-overflow: ellipsis;
}
@media (max-width: 1200px) {
  .serialNumber__Isott {
    width: 100%;
    min-width: auto;
    max-width: 195px;
  }
}

.copyIcon__PkBri {
  cursor: pointer;
}
.copyIcon__PkBri path {
  fill: var(--buttons-surface);
}

.historyTable___3DvL {
  width: 100%;
}

.historyTableHead__AcwOZ {
  box-shadow: var(--select-dropdown-box-shadow);
}

.historyTableHeadCell__ZxfYx {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: var(--tables-title-text);
  text-transform: uppercase;
  text-align: left;
  padding: 16px 15px;
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
  position: sticky;
  top: 100px;
  z-index: 2;
}
.historyTableHeadCell__ZxfYx:first-child {
  padding-left: 25px;
  cursor: pointer;
}

.historyTableBodyRow__gBXoc:hover td {
  background: var(--tables-primary-row-surface-hover);
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  cursor: pointer;
}

.historyTableBodyCell__t5HFg {
  font-size: 14px;
  line-height: 14px;
  color: var(--tables-primary-row-text-main);
  padding: 16px 15px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
}
.historyTableBodyCell__t5HFg:first-child {
  padding-left: 25px;
}

.actionsInfo__q9AMf {
  max-width: 300px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/AiHistory/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,6CAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,yDAAA;EACA,qDAAA;EACA,mCAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,yCAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iCAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iDAAA;EACA,uBAAA;AAzEF;AA2EE;EAXF;IAYI,WAAA;IACA,eAAA;IACA,gBAAA;EAxEF;AACF;;AA2EA;EACE,eAAA;AAxEF;AA0EE;EACE,4BAAA;AAxEJ;;AA4EA;EACE,WAAA;AAzEF;;AA4EA;EACE,6CAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mDAAA;EACA,uCAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AAzEF;AA2EE;EACE,kBAAA;EACA,eAAA;AAzEJ;;AA8EE;EACE,mDAAA;EACA,yDAAA;EACA,eAAA;AA3EJ;;AA+EA;EACE,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,kBAAA;EACA,yDAAA;EACA,qDAAA;AA5EF;AA8EE;EACE,kBAAA;AA5EJ;;AAgFA;EACE,gBAAA;AA7EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.historyPageBody {\n  padding: 25px;\n}\n\n.historyPageBodyContainer {\n  position: relative;\n  box-shadow: var(--select-dropdown-box-shadow);\n}\n\n.historyPageInfoPanel {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  padding: 15px 25px;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n  background: var(--tables-primary-row-surface-default);\n  box-shadow: var(--table-box-shadow);\n}\n\n.leftPart {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.equipmentNameLabel {\n  font-size: 11px;\n  line-height: 14px;\n  font-weight: 400;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  font-style: normal;\n}\n\n.equipmentName {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 20px;\n  color: var(--tables-primary-row-text-main);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-transform: uppercase;\n  margin-top: 5px;\n  padding: 7px 0 8px;\n}\n\n.serialNumberLabel {\n  color: var(--title-inputs-sections-title);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n}\n\n.serialNumberField {\n  display: flex;\n  align-items: center;\n  column-gap: 5px;\n  margin-top: 5px;\n}\n\n.serialNumber {\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 12px;\n  color: var(--inputs-disable-text);\n  min-width: 195px;\n  padding: 11px 15px 12px;\n  border-radius: 2px;\n  background: var(--inputs-disable-disable-surface);\n  text-overflow: ellipsis;\n\n  @media (max-width: 1200px) {\n    width: 100%;\n    min-width: auto;\n    max-width: 195px;\n  }\n}\n\n.copyIcon {\n  cursor: pointer;\n\n  path {\n    fill: var(--buttons-surface);\n  }\n}\n\n.historyTable {\n  width: 100%;\n}\n\n.historyTableHead {\n  box-shadow: var(--select-dropdown-box-shadow);\n}\n\n.historyTableHeadCell {\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  color: var(--tables-title-text);\n  text-transform: uppercase;\n  text-align: left;\n  padding: 16px 15px;\n  border-bottom: 1px solid var(--tables-title-stroke);\n  background: var(--tables-title-surface);\n  position: sticky;\n  top: 100px;\n  z-index: 2;\n\n  &:first-child {\n    padding-left: 25px;\n    cursor: pointer;\n  }\n}\n\n.historyTableBodyRow {\n  &:hover td {\n    background: var(--tables-primary-row-surface-hover);\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    cursor: pointer;\n  }\n}\n\n.historyTableBodyCell {\n  font-size: 14px;\n  line-height: 14px;\n  color: var(--tables-primary-row-text-main);\n  padding: 16px 15px;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n  background: var(--tables-primary-row-surface-default);\n\n  &:first-child {\n    padding-left: 25px;\n  }\n}\n\n.actionsInfo {\n  max-width: 300px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"historyPageBody": `historyPageBody__h5YTI`,
	"historyPageBodyContainer": `historyPageBodyContainer__yACtq`,
	"historyPageInfoPanel": `historyPageInfoPanel__RXAdF`,
	"leftPart": `leftPart__i_gH4`,
	"equipmentNameLabel": `equipmentNameLabel__yqNeg`,
	"equipmentName": `equipmentName__uZ2a5`,
	"serialNumberLabel": `serialNumberLabel__vavqc`,
	"serialNumberField": `serialNumberField__B57VH`,
	"serialNumber": `serialNumber__Isott`,
	"copyIcon": `copyIcon__PkBri`,
	"historyTable": `historyTable___3DvL`,
	"historyTableHead": `historyTableHead__AcwOZ`,
	"historyTableHeadCell": `historyTableHeadCell__ZxfYx`,
	"historyTableBodyRow": `historyTableBodyRow__gBXoc`,
	"historyTableBodyCell": `historyTableBodyCell__t5HFg`,
	"actionsInfo": `actionsInfo__q9AMf`
};
module.exports = ___CSS_LOADER_EXPORT___;
